import { render, staticRenderFns } from "./UpgradeUser.vue?vue&type=template&id=2ce789f1&scoped=true"
import script from "./UpgradeUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpgradeUser.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UpgradeUser.vue?vue&type=style&index=0&id=2ce789f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce789f1",
  null
  
)

export default component.exports